export default __webpack_public_path__ + "static/media/Spin torre RI_Interactive LightMix0001.10bda259.webp";